import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class StorageService {

  constructor() { }

  /**
   * @deprecated: one should not use the old OAuth flow. Use WorkOS instead
   * src/app/services/workos.service.ts
   */
  public setBearer(bearer) {
    throw new Error("setBearer is deprecated");
    this._setValue('bearer', bearer);
  }

  /**
   * @deprecated: one should not use the old OAuth flow. Use WorkOS instead
   * src/app/services/workos.service.ts
   */
  public getBearer() {
    throw new Error("getBearer is deprecated");
    return this._getValue('bearer');
  }

  /**
   * @deprecated: one should not use the old OAuth flow. Use WorkOS instead
   * src/app/services/workos.service.ts
   */
  public setAzureToken(token) {
    throw new Error("setAzureToken is deprecated");
    this._setValue('azure_token', token);
  }

  /**
   * @deprecated: one should not use the old OAuth flow. Use WorkOS instead
   * src/app/services/workos.service.ts
   */
  public setPkceState(pkceState) {
    throw new Error("setPkceState is deprecated");
    this._setValue('pkceState', pkceState);
  }

  /**
   * @deprecated: one should not use the old OAuth flow. Use WorkOS instead
   * src/app/services/workos.service.ts
   */
  public setPkceCodeVerifier(pkceCodeVerifier) {
    throw new Error("setPkceCodeVerifier is deprecated");
    this._setValue('pkceCodeVerifier', pkceCodeVerifier);
  }

  /**
   * @deprecated: one should not use the old OAuth flow. Use WorkOS instead
   * src/app/services/workos.service.ts
   */
  public getPkceState() {
    throw new Error("getPkceState is deprecated");
    return this._getValue('pkceState');
  }

  /**
   * @deprecated: one should not use the old OAuth flow. Use WorkOS instead
   * src/app/services/workos.service.ts
   */
  public getPkceCodeVerifier() {
    throw new Error("getPkceCodeVerifier is deprecated");
    return this._getValue('pkceCodeVerifier');
  }

  /**
   * @deprecated: one should not use the old OAuth flow. Use WorkOS instead
   * src/app/services/workos.service.ts
   */
  public getAzureToken() {
    throw new Error("getAzureToken is deprecated");
    return this._getValue('azure_token');
  }

  /**
   * @deprecated: one should not use the old OAuth flow. Use WorkOS instead
   * src/app/services/workos.service.ts
   */
  public setAzureAppId(appid) {
    throw new Error("setAzureAppId is deprecated");
    this._setValue('azure_app_id', appid);
  }

  /**
   * @deprecated: one should not use the old OAuth flow. Use WorkOS instead
   * src/app/services/workos.service.ts
   */
  public getAzureAppId(): string {
    throw new Error("getAzureAppId is deprecated");
    return this._getValue('azure_app_id');
  }

  /**
   * @deprecated: one should not use the old OAuth flow. Use WorkOS instead
   * src/app/services/workos.service.ts
   */
  public setAzureTenantId(tenant_id) {
    throw new Error("setAzureTenantId is deprecated");
    this._setValue('tenant_id', tenant_id);
  }

  /**
   * @deprecated: one should not use the old OAuth flow. Use WorkOS instead
   * src/app/services/workos.service.ts
   */
  public getAzureTenantId(): string {
    throw new Error("getAzureTenantId is deprecated");
    return this._getValue('tenant_id');
  }

  /**
   * @deprecated: one should not use the old OAuth flow. Use WorkOS instead
   * src/app/services/workos.service.ts
   */
  public setClientBearer(clientBearer) {
    throw new Error("setClientBearer is deprecated");
    this._setValue('bearer_client', clientBearer);
  }

  /**
   * @deprecated: one should not use the old OAuth flow. Use WorkOS instead
   * src/app/services/workos.service.ts
   */
  public getClientBearer() {
    throw new Error("getClientBearer is deprecated");
    return this._getValue('clientBearer');
  }

  /**
   * @deprecated: one should not use the old OAuth flow. Use WorkOS instead
   * src/app/services/workos.service.ts
   */
  public setRefreshToken(refreshToken) {
    throw new Error("setRefreshToken is deprecated");
    this._setValue('refresh_token', refreshToken);
  }

  /**
   * @deprecated: one should not use the old OAuth flow. Use WorkOS instead
   * src/app/services/workos.service.ts
   */
  public getRefreshToken() {
    throw new Error("getRefreshToken is deprecated");
    return this._getValue('refresh_token');
  }

  /**
   * @deprecated: one should not use the old OAuth flow. Use WorkOS instead
   * src/app/services/workos.service.ts
   */
  public setTokenExpiration(time) {
    throw new Error("setTokenExpiration is deprecated");
    this._setValue('token_expiration', time);
  }

  /**
   * @deprecated: one should not use the old OAuth flow. Use WorkOS instead
   * src/app/services/workos.service.ts
   */
  public getTokenExpiration(): any {
    throw new Error("getTokenExpiration is deprecated");
    return this._getValue('token_expiration');
  }

  public setCurrentOrganisation(organisationId) {
    this._setValue('organisation_id', organisationId);
  }

  public getCurrentOrganisation() {
    return this._getValue('organisation_id');
  }

  public storeOAuthResponse(response) {
    this.setBearer(response.access_token);
    this.setRefreshToken(response.refresh_token);
    this.setTokenExpiration( Math.floor(Number(Date.now()) / 1000) + Number(response.expires_in));
  }

  public cleanOAuth() {
    this._forget('bearer');
    this._forget('refresh_token');
    this._forget('token_expiration');
    this._forget('organisation_id');
    this._forget('azure_token');
    this._forget('azure_app_id');
  }

  public setLanguage(lang) {

    if (lang !== 'fr' && lang !== 'nl' && lang !== 'en' && lang !== 'es') {
      lang = 'en';
    }

    this._setValue('language', lang);
  }

  public getLanguage() {
    let lang = this._getValue('language');

    if (lang !== 'fr' && lang !== 'nl' && lang !== 'en' && lang !== 'es') {
        lang = 'en';
    }

    return lang;
  }

  public setLocalId(lang) {
    this._setValue('localId', lang);
  }

  public getLocalId() {
    return this._getValue('localId');
  }

  public setThrottleTime(time: number) {
    this._setValue('throttle', time);
  }

  public isThrottleTimePassed() {

    if (this._getValue('throttle') === null) {
        this.setThrottleTime(Date.now() - 3000);
    }

    const isThrottleTimePassed = parseInt(this._getValue('throttle')) < Date.now();

    this.setThrottleTime(Date.now() + 3000);

    return isThrottleTimePassed;
  }

  public setDismissBanner(bannerId) {
    this._setValue('banner_' + bannerId, '1');
  }
  public isBannerDismissed(bannerId) {
    return this._getValue('banner_' + bannerId) === '1';
  }

  public getWorkosRefreshToken() {
    return this._getValue('workos:refresh-token');
  }

  private _getValue(key) {
    return window.localStorage.getItem(key);
  }

  private _setValue(key, value) {
    window.localStorage.setItem(key, value);
  }

  private _forget(key) {
    window.localStorage.removeItem(key);
  }
}
